import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

import { getClassName as baseGetClassName } from "react-suitcssify/dist/lib/utility";
import { configuration } from "../index";
export var getClassName = function getClassName(args) {
  return baseGetClassName(_objectSpread({
    namespace: configuration.current.styles.namespace
  }, args));
};
export var getClassNameFactory = function getClassNameFactory(componentName) {
  return function (args) {
    return getClassName(_objectSpread({
      componentName: componentName
    }, args));
  };
};
export default getClassNameFactory;